import { Bcrypt } from "../utils"
import { IAMService } from '../services'
import { SET_USER_DATA, USE_2FA } from '../constants/IAMActionTypes'
import { SET_APP_CONFIG, SET_MIGRATION_STATUS } from '../constants/AppActionType'
import { CLEAR_LOGIN_DATA, CLEAR_STORE_DATA } from "../constants/ClearStoreActionType"
import IAMAService from "../services/IAMService"
import QRCode from "qrcode"

const registration = (payload, password, setStatus, setData) => {
    setStatus(1)
    Bcrypt.password_hash_manager.hash_password(password).then((password_hash) => {
        setStatus(2)
        const __payload = ({ ...payload, password: password_hash })
        IAMService.registration(__payload).then((response) => {
            if (response.data.status === 'SUCCESS') {
                setData(__payload)
                setStatus(3)
            } else if (response.data.status === 'USER_EXISTS') {
                setData(__payload)
                setStatus(4)
            } else {
                setStatus(-1)
            }
        }).catch((error) => {
            // Surface backend failures (incl. HTTP 403 when the portal is
            // read-only) via the existing "Registration Failed" state instead
            // of leaving the UI stuck on "Registration pending...".
            console.error(error)
            setStatus(-1)
        })
    }).catch((error) => {
        console.error(error)
        setStatus(-1)
    })
}

const logout = (dispatch) => {
    dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_OUT" } })
    dispatch({ type: CLEAR_STORE_DATA })
    dispatch({ type: CLEAR_LOGIN_DATA })
    userReset()
}

const login = (username, password, dispatch) => {
    dispatch({ type: SET_USER_DATA, value: { status: "WORKING" } })
    Bcrypt.password_hash_manager.hash_password(password).then((password_hash) => {
        IAMService.login({ username: username, password: password_hash }).then((response) => {
            const { status, data } = response.data
            if (status === 'SUCCESS') {
                if (data.approved === 3) {
                    if (data.islocked < 3) {
                        localStorage.setItem('bearer_token', data.bearer_token)
                        dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_IN", ...data } })
                        dispatch({ type: USE_2FA, value: data.twofactor === 1 })
                    } else {
                        dispatch({ type: SET_USER_DATA, value: { status: "USER_ACCOUNT_LOCKED", ...data } })
                    }
                } else {
                    dispatch({ type: SET_USER_DATA, value: { status: "UNAPPROVED_LOGGED_IN", ...data } })
                }
            } else if (status === 'PASSWORD_ERROR') {
                dispatch({ type: SET_USER_DATA, value: { islocked: response.data.locked, status: status } })
            } else if (status === 'USER_ACCOUNT_LOCKED') {
                dispatch({ type: SET_USER_DATA, value: { status: "USER_ACCOUNT_LOCKED", ...data } })
            } else {
                dispatch({ type: SET_USER_DATA, value: { status: status } })
                userReset()
            }
        }).catch((error) => {
            console.error(error)
            logout(dispatch)
        })
    }).catch((error) => {
        console.error(error)
        logout(dispatch)
    })
}

const autologin = (dispatch) => {
    const token = localStorage.getItem('bearer_token')
    if (token !== undefined && token !== null) {
        dispatch({ type: SET_USER_DATA, value: { status: "WORKING" } })
        IAMService.autologin().then((response) => {
            const { status, data } = response.data
            if (status === 'SUCCESS') {
                if (data.approved === 3) {
                    if (data.islocked < 3) {
                        localStorage.setItem('bearer_token', data.bearer_token)
                        dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_IN", ...data } })
                        dispatch({ type: USE_2FA, value: data.twofactor === 1 })
                    } else {
                        dispatch({ type: SET_USER_DATA, value: { status: "USER_ACCOUNT_LOCKED", ...data } })
                    }
                } else {
                    dispatch({ type: SET_USER_DATA, value: { status: "UNAPPROVED_LOGGED_IN", ...data } })
                }
            } else {
                dispatch({ type: SET_USER_DATA, value: { status: "UNREGISTERED" } })
                userReset()
            }
        }).catch((error) => {
            console.error(error)
            logout(dispatch)
        })
    }
}

const password_reset = (username, currentpassword, newpassword, setStatus) => {
    setStatus(1)
    var payload = { username: username }
    Bcrypt.password_hash_manager.hash_password(currentpassword).then((currentpassword_hash) => {
        setStatus(2)
        payload = { ...payload, currentpassword: currentpassword_hash }
        Bcrypt.password_hash_manager.hash_password(newpassword).then((newpassword_hash) => {
            setStatus(3)
            payload = { ...payload, newpassword: newpassword_hash }
            IAMService.password_reset(payload).then((response) => {
                setStatus(response.data.status === 'SUCCESS' ? 4 : -1)
            }).catch(console.error)
        }).catch(console.error)
    }).catch(console.error)
}

const forgot_password = (payload, setStatus) => IAMService.forgot_password(payload).then((response) => setStatus(response.data.status)).catch((error) => setStatus('ERROR'))

const userReset = () => {
    localStorage.removeItem("bearer_token")
}

const twoFactor = {
    generateSecret: (username, setData, setStatus) => {
        setStatus('WORKING')
        IAMAService.twoFactor.generateSecret(username).then((response) => {
            if (response.data.status === 'SUCCESS') QRCode.toDataURL(response.data.data).then((iamgeData) => setData(iamgeData)).catch(console.error)
            setStatus(response.data.status)
        }).catch(console.error)
    },
    verify: (username, userToken, setStatus) => {
        setStatus({ status: 'WORKING' })
        IAMAService.twoFactor.verify(username, userToken).then((response) => {
            setStatus(response.data)
        }).catch(console.error)
    }
}

const getUsers = (username, updateUsers) => {
    updateUsers({ 'status': 'WORKING', data: [], 'reason': '' })
    IAMService.getUsers(username).then((response) => updateUsers(response.data)).catch((error) => updateUsers({ 'status': 'ERROR', data: [], 'reason': error }))
}

const approverUser = (payload, updateStatus) => {
    updateStatus('WORKING')
    IAMService.approverUser(payload).then((response) => updateStatus(response.data.status)).catch((error) => updateStatus('ERROR'))
}

const bulkApproverUser = (payload, updateStatus) => {
    updateStatus('WORKING')
    IAMService.bulkApproverUser(payload).then((response) => updateStatus(response.data.status)).catch((error) => updateStatus('ERROR'))
}

const toggleLock = (username, updateStatus) => {
    updateStatus('WORKING')
    IAMService.toggleLock(username).then((response) => updateStatus(response.data.status)).catch((error) => updateStatus('ERROR'))
}

const getRegistrationMetadata = (setData) => IAMService.getRegistrationMetadata().then((response) => setData(response.data)).catch((error) => setData({ status: "ERROR", data: { companyList: [], customerList: [], managers: [] } }))

const editUser = (payload) => IAMService.editUser(payload)

const addCompany = (addCustomer, setAddCustomer) => {
    setAddCustomer({ ...addCustomer, status: "WORKING" })
    IAMService.addCompany(addCustomer.customer).then((response) => setAddCustomer({ ...addCustomer, customer: "", status: response.data.status })).catch((error) => setAddCustomer({ ...addCustomer, status: "ERROR" }))
}

const reset2FA = (username) => IAMAService.reset2FA({ username })

const resetPassword = (username) => IAMAService.resetPassword({ username })

// Fetch the public app config (read-only / migration flags + links) and store it.
const getAppConfig = (dispatch) => {
    IAMAService.getAppConfig().then((response) => {
        const { status, data } = response.data
        if (status === 'SUCCESS' && data) {
            dispatch({
                type: SET_APP_CONFIG,
                value: {
                    readOnly: !!data.read_only,
                    migrationEnabled: !!data.migration_enabled,
                    newAppUrl: data.new_app_url || '',
                    supportEmail: data.support_email || '',
                },
            })
        }
    }).catch((error) => console.error('Failed to load app config', error))
}

// Trigger self-migration of the logged-in user into the new ESP app.
// Resolves with { status, newAppUrl, reason } so the dialog can react.
const migrate = (dispatch) => {
    dispatch({ type: SET_MIGRATION_STATUS, value: 'WORKING' })
    return IAMAService.migrate().then((response) => {
        const { status, new_app_url, reason } = response.data
        const result = { status: status || 'ERROR', newAppUrl: new_app_url || '', reason: reason || '' }
        dispatch({ type: SET_MIGRATION_STATUS, value: result.status === 'SUCCESS' ? 'SUCCESS' : 'ERROR' })
        return result
    }).catch((error) => {
        console.error('Migration failed', error)
        dispatch({ type: SET_MIGRATION_STATUS, value: 'ERROR' })
        return { status: 'ERROR', newAppUrl: '', reason: 'Migration request failed.' }
    })
}

const resetMigrationStatus = (dispatch) => dispatch({ type: SET_MIGRATION_STATUS, value: 'IDLE' })

const IAMAction = {
    registration,
    login,
    autologin,
    password_reset,
    forgot_password,
    logout,
    twoFactor,
    editUser,
    getUsers,
    approverUser,
    bulkApproverUser,
    toggleLock,
    getRegistrationMetadata,
    addCompany,
    reset2FA,
    resetPassword,
    getAppConfig,
    migrate,
    resetMigrationStatus,
}

export default IAMAction
